
class SingleAide {
  private container: HTMLElement | null;
  private header: HTMLElement | null;
  private triggers?: NodeListOf<HTMLButtonElement>;
  private targets?: HTMLElement[];
  private observer: IntersectionObserver | null = null;
  private isScrollingViaClick: boolean = false;

  constructor() {
    this.container = document.querySelector('.single-aide')
    this.header = document.querySelector('header');

    if (!this.container)
      return
    if (this.container) {
      this.triggers = this.container.querySelectorAll('[data-single-aide-scroll-to]');
      this.targets = [];
      this.mapTargets();
      this.initClickListeners();
      this.initScrollObserver();
      this.initFormScrollListener();
      this.initAncreSelectListener();
    }
  }


  private mapTargets(): void {
    this.triggers?.forEach(trigger => {
      const targetId = trigger.dataset.singleAideScrollTo;
      if (targetId) {
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          this.targets?.push(targetElement);
        }
      }
    });
  }


  private setActive(activeTrigger: HTMLButtonElement): void {
    this.triggers?.forEach(t => t.classList.remove('active'));
    activeTrigger.classList.add('active');
  }

  private initClickListeners(): void {
    this.triggers?.forEach(trigger => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();

        this.setActive(trigger);

        this.isScrollingViaClick = true;

        const targetId = trigger.dataset.singleAideScrollTo;
        if (targetId) {
          const targetElement = document.getElementById(targetId);
          if (targetElement) {
            this.scrollToTarget(targetElement, true);
          }
        }
      });
    });
  }

  private initScrollObserver(): void {
    if (!this.header) return;

    const headerHeight = this.header.offsetHeight;
    const options = {
      rootMargin: `-${headerHeight}px 0px -40% 0px`,
    };

    this.observer = new IntersectionObserver((entries) => {
      if (this.isScrollingViaClick) {
        return;
      }

      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const trigger = this.container?.querySelector<HTMLButtonElement>(`[data-single-aide-scroll-to="${entry.target.id}"]`);
          if (trigger) {
            this.setActive(trigger);
          }
        }
      });
    }, options);

    this.targets?.forEach(target => this.observer?.observe(target));
  }

  private scrollToTarget(targetElement: HTMLElement, takeHeader: boolean): void {
    const headerHeight = (takeHeader && this.header) ? this.header.offsetHeight : 20;

    const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
    const scrollTargetY = targetPosition - headerHeight;

    window.scrollTo({
      top: scrollTargetY,
      behavior: 'smooth'
    });

    setTimeout(() => {
      this.isScrollingViaClick = false;
    }, 800);
  }
  private initFormScrollListener(): void {
    const formScrollButton = document.querySelector<HTMLButtonElement>('[data-single-aide-scroll]');
    const formTarget = document.getElementById('form');

    if (formScrollButton && formTarget) {
      formScrollButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.scrollToTarget(formTarget, true);
      });
    }
  }

  private initAncreSelectListener(): void {
    const selectElement = this.container?.querySelector<HTMLSelectElement>('#ancres');

    if (!selectElement) {
      return;
    }

    selectElement.addEventListener('change', () => {
      const targetId = selectElement.value;

      if (!targetId) {
        return;
      }

      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        this.scrollToTarget(targetElement, false);
      }
    });
  }
}

export const singleAide = new SingleAide();
